import type { AxiosResponse } from 'axios'

import axiosInstance from '@/axios'
import { type TEntityInfo } from '@/interfaces'

const formRequests = {
  getCurrentForm: async (): Promise<AxiosResponse<TEntityInfo[]>> => {
    return await axiosInstance.get('/entity/execute/entityDefs')
  },
}

export default formRequests
